export default "__VITE_ASSET__DX3JCbLs__"